// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "graphic".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { aspectRatioValues, graphicStatusValues, graphicUsageTypeValues } from '@borradh-workspace/labels';
/** Response atom for the "graphic" table (1:1 with a DB row, on the wire). */
export const graphicAtomSchema = z.object({
    id: z.string(),
    title: z.string().nullable(),
    status: z.enum(graphicStatusValues),
    usageType: z.enum(graphicUsageTypeValues),
    serviceId: z.string().nullable(),
    topicSummary: z.string().nullable(),
    kind: z.string(),
    templateSlug: z.string().nullable(),
    renderedCopy: z.string().nullable(),
    offerId: z.string().nullable(),
    sourceAssetIds: z.array(z.string()).nullable(),
    slideAssetIds: z.unknown().nullable(),
    allowAiImages: z.boolean().nullable(),
    imageryPolicy: z.string().nullable(),
    includeLogo: z.boolean().nullable(),
    logoPlacement: z.string().nullable(),
    aspectRatio: z.enum(aspectRatioValues).nullable(),
    canvasWidth: z.number().nullable(),
    canvasHeight: z.number().nullable(),
    outputs: z.unknown().nullable(),
    errorCode: z.string().nullable(),
    errorMessage: z.string().nullable(),
    organizationId: z.string(),
    createdById: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=graphic.js.map